import { Country } from '@/helpers/conf';
import { isCountryAllowed } from './isCountryAllowed';

// countryCode can leak the raw i18n locale (e.g. 'de', 'en-AU') when no real
// geo header is present; only trust it if it's an actual ISO country code.
const isValidCountryCode = (code?: string): code is Country =>
  !!code && (Object.values(Country) as string[]).includes(code);

export const checkHeadlinePromoCountryMatch = (
  allowedCountries?: string[],
  disallowedCountries?: string[],
  rawCountryCode?: string
): boolean => {
  const countryCode = isValidCountryCode(rawCountryCode)
    ? rawCountryCode
    : undefined;
  const hasCountryRestriction =
    !!allowedCountries?.length || !!disallowedCountries?.length;
  // A restricted config must fail closed when the country can't be resolved —
  // only a config with no restriction at all passes for an unknown country.
  if (!countryCode) return !hasCountryRestriction;
  return isCountryAllowed(countryCode, allowedCountries, disallowedCountries);
};
